module.exports = __webpack_public_path__ + "img/logo8.c9cc8015.png";